module.exports = __webpack_public_path__ + "img/save.96b29e9a.svg";